import { ImageEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import getSourceSetValues from '../helpers/getSourceSetValues';
import { resizeImageSourceMax } from '../helpers/resizeImageSource';

const ComposableArticleHeaderImage = ({ url, ...props }) => (
  <GridItem
    fullWidthItemSm
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartLg="2"
    columnEndLg="span 10"
  >
    <ImageEmbed
      src={resizeImageSourceMax(url, 16 / 9)}
      srcSet={getSourceSetValues(url, 16 / 9).join(', ')}
      {...props}
    />
  </GridItem>
);

ComposableArticleHeaderImage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ComposableArticleHeaderImage;
